export enum NFCeContingenciaRefinamentoEnum {
    numero = 1,
    cliente = 2,
}
